import { FormattedMessage } from 'react-intl'
import { Box } from '@mui/material'
import { Typography } from '@carto/meridian-ds/components'

export function HelpHeader() {
  return (
    <Box display="flex" alignItems="center">
      <Typography variant="h6">
        <FormattedMessage id="helpPanel.helpAndResources" />
      </Typography>
    </Box>
  )
}

export default HelpHeader
